<template>
  <div class="site-title">
    <div class="site-title__seal" aria-hidden="true">
      <img src="/assets/aihub.png" alt="AI灵感库 Logo" class="site-title__seal-img">
    </div>
    <p v-if="eyebrow" class="site-title__eyebrow">{{ eyebrow }}</p>
    <h1 class="site-title__display">{{ title }}</h1>
    <div class="site-title__rule" aria-hidden="true">
      <span class="site-title__rule-line"></span>
      <span class="site-title__rule-mark">&#9670;</span>
      <span class="site-title__rule-line"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteTitle',
  props: {
    // 主标题（已解析的文本，如 $t('interface.title.home')）
    title: {
      type: String,
      required: true
    },
    // 小号 kicker（可选），如 “AI灵感库 · 每周精选”
    eyebrow: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
/* 编辑风标题区域 — 压扁，不抢下方主体视线（首页/融资页共享） */
.site-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.25rem 1rem 0.5rem;
  animation: site-title-rise 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

/* 品牌印记：小尺寸圆形 logo + 暖金细环 */
.site-title__seal {
  width: 44px;
  height: 44px;
  padding: 2px;
  border-radius: 9999px;
  border: 1px solid var(--brass-hairline, #cdbfa6);
  background: #fff;
  display: grid;
  place-items: center;
  margin-bottom: 0.7rem;
  box-shadow: 0 1px 2px rgba(26, 22, 18, 0.06);
}
.site-title__seal-img {
  width: 100%;
  height: 100%;
  border-radius: 9999px;
  object-fit: cover;
  display: block;
}

/* 小号 kicker：品牌名 + 精选标签 */
.site-title__eyebrow {
  margin: 0 0 0.35rem;
  font-family: var(--font-sans, -apple-system, system-ui, sans-serif);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-indent: 0.22em; /* 抵消尾部字距，视觉居中 */
  color: var(--text-muted, #8a8175);
}

/* 主标题：墨黑衬线展示体，尺寸收敛 */
.site-title__display {
  margin: 0;
  font-family: var(--font-display, "Noto Serif SC", "Songti SC", serif);
  font-weight: 600;
  font-size: clamp(1.8rem, 4.8vw, 2.75rem);
  line-height: 1.1;
  letter-spacing: 0.02em;
  color: var(--ink, #1b1815);
  text-wrap: balance;
}

/* 细分割线 + 中央菱形装饰 */
.site-title__rule {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: min(240px, 70%);
  margin: 0.6rem 0 0.25rem;
}
.site-title__rule-line {
  flex: 1;
  height: 1px;
  background: var(--brass-rule, #e0d8c6);
}
.site-title__rule-mark {
  color: var(--brass, #b39a6b);
  font-size: 0.6rem;
  line-height: 1;
}

@keyframes site-title-rise {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .site-title { animation: none; }
}
</style>
